import React from 'react';
import { TextLink } from '@spotify-internal/encore-web';

import ArticleLink from './ArticleLink';
import ChildCategoryLink from './ChildCategoryLink';
import HomeLink from './HomeLink';
import ParentCategoryLink from './ParentCategoryLink';

export { ArticleLink, ParentCategoryLink, ChildCategoryLink, HomeLink };

// This function will return a wrapper component that throws away the className
export const omitClassName = (Component: (props: Parameters<typeof TextLink>[0]) => React.ReactElement) => {
  return ({ className, ...props }: Parameters<typeof TextLink>[0]) => <Component {...props} />;
};
